import { makeStyles, Box, Button, Typography, Grid } from '@material-ui/core'
import React from 'react'
import Oculto from './Oculto'
import { Link } from 'react-router-dom'

const estilos = makeStyles((theme) => ({
  botonPersonalizado: {
    background: 'linear-gradient(45deg, #018786 30%, #018786 90%)',
    border: 0,
    borderRadius: 100,
    color: 'white',
    height: 48,
    padding: '5px 20px',
    fontSize: 20,
    fontWeight: 400,
    width: 140,
    marginBottom: 50,
  },
}))

const Inicio = ({ formState, setFormState }) => {
  const classes = estilos()

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      height="100%"
    >
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={4} mt="15%">
          <Typography variant="h2" color="initial">
            ¿Quieres saber si tienes COVID-19?
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={6} alignItems="left">
          <Typography variant="body2">
            La COVID-19 es la enfermedad infecciosa causada por el coronavirus
            SARS-CoV-2, un patógeno respiratorio.
          </Typography>
        </Box>
      </Grid>

      {formState.name == '' &&
      formState.age == 0 &&
      formState.radioAFiebre == 'end' &&
      formState.radioBTos == 'end' &&
      formState.radioCGarganta == 'end' &&
      formState.radioDDiarrea == 'end' &&
      formState.radioEOlfato == 'end' &&
      formState.radioFErupciones == 'end' &&
      formState.radioGColor == 'end' &&
      formState.radioHRespirar == 'end' ? (
        <Link to="/test" className="navbarLinks">
          <Button
            size="large"
            className={classes.botonPersonalizado}
            disableElevation
          >
            COMENZAR
          </Button>
        </Link>
      ) : (
        <Link to="/test" className="navbarLinks">
          <Button
            size="large"
            className={classes.botonPersonalizado}
            disableElevation
            style={{ fontSize: '12px' }}
            onClick={() =>
              setFormState({
                name: '',
                age: 0,
                radioAFiebre: 'end',
                radioBTos: 'end',
                radioCGarganta: 'end',
                radioDDiarrea: 'end',
                radioEOlfato: 'end',
                radioFErupciones: 'end',
                radioGColor: 'end',
                radioHRespirar: 'end',
              })
            }
          >
            NUEVA PRUEBA
          </Button>
        </Link>
      )}

      <Grid item>
        <Box ml={4}>
          <Typography variant="body2">
            Comienza tu test online ahora mismo.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export default Inicio
